"use client";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SearchPageBrandSearch } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageBrandSearch/SearchPageBrandSearch";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SearchPageFeaturedProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageFeaturedProducts/SearchPageFeaturedProducts";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SearchResultsWrapper } from "@faire/deprecated-retailer-visitor-shared/views/search/__internal__/SearchProductsPage/__internal__/SearchStyles";
import { useIsLoggedInRetailer } from "@faire/marketplace-lib/serialized-data/isLoggedInRetailer";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import React, { ReactNode } from "react";

/** Please do not depend on the data layer in this layout component. */
export const SearchPageLayout = ({
  filterAndResults,
  footer,
}: {
  filterAndResults: ReactNode;
  footer: ReactNode;
}) => {
  useTraceComponentRender("SearchPageLayout");

  const isLoggedInRetailer = useIsLoggedInRetailer();
  return (
    <>
      <SearchResultsWrapper $addDesktopGutter>
        <SearchPageFeaturedProducts />
        {!isLoggedInRetailer ? <SearchPageBrandSearch /> : null}
        {filterAndResults}
        {footer}
      </SearchResultsWrapper>
    </>
  );
};
